// extracted by mini-css-extract-plugin
module.exports = {"starsInfoBlock":"_ae3ad01","restrictedWidth":"_1887af6"};